import posthog from 'posthog-js';
import { PostHogProvider as PostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import store from 'common/middleware/store';

interface Props {
  children: React.ReactNode,
}

export const PostHogProvider = function PostHogProvider({ children }: Props) {
  const { isDevEnv } = useSnapshot(store);

  if (isDevEnv) {
    return children;
  }

  return (
    <PostHogInitializer>{children}</PostHogInitializer>
  );
}

const PostHogInitializer = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: "/ingest",
      ui_host: "https://us.posthog.com",
      defaults: '2025-05-24',
      debug: process.env.NODE_ENV === 'development',
      autocapture: false,
      capture_exceptions: true,
      capture_pageleave: false,
      capture_pageview: false,
      cookieless_mode: "on_reject",
      loaded: (ph) => {
        if (location.hostname.includes("qa")) {
          ph.opt_in_capturing();
        } else {
          ph.opt_out_capturing();
        }
      },
    });
  }, []);

  return (
    <PostHog client={posthog}>
      {children}
    </PostHog>
  )
}
